import { useContext } from 'react'
import RunIcon from '../img/run.png'
import Run2Icon from '../img/run2.png'
import JumpingIcon from '../img/jump.png'
import FailIcon from '../img/fail.png'
import Context from '../Context'

function Person() {
  const { requestCount } = useContext(Context)

  const getIcon = (count) => {
    if (count === -1) {
      return FailIcon
    } else if (count % 4 === 0) {
      return JumpingIcon
    } else if (count % 4 % 2 === 1) {
      return Run2Icon
    } else {
      return RunIcon
    }
  }

  return(
    <img
      src={getIcon(requestCount)}
      alt={requestCount % 5 === 0 ? 'Jumping' : 'Running'}
      height="23px"
    />
  )
}

export default Person